import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

const PreviewOnlyIcon = ({ color = '#0d84fe', size = '37', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 37 25"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M21.75 18H2.25A2.25 2.25 0 0 1 0 15.75V2.25A2.25 2.25 0 0 1 2.25 0h19.5A2.25 2.25 0 0 1 24 2.25v13.5A2.25 2.25 0 0 1 21.75 18zM5.25 2.625a2.625 2.625 0 1 0 0 5.25 2.625 2.625 0 0 0 0-5.25zM3 15h18V9.75l-4.102-4.102a.563.563 0 0 0-.796 0L9.75 12 7.148 9.398a.563.563 0 0 0-.796 0L3 12.75V15z"
        fill={color}
        fillRule="nonzero"
      />
      <g transform="translate(17 5)">
        <circle fill="#FFF" cx="9.5" cy="9.5" r="6.5" />
        <path
          d="M20 10c0-1.473-.926-2.73-2.23-3.219a3.437 3.437 0 0 0-4.551-4.55 3.436 3.436 0 0 0-6.438 0 3.436 3.436 0 0 0-4.55 4.55 3.436 3.436 0 0 0 0 6.438 3.436 3.436 0 0 0 4.55 4.55 3.436 3.436 0 1 0 6.438 0 3.437 3.437 0 1 0 4.55-4.55A3.436 3.436 0 0 0 20 10zm-9.063 3.69v.685c0 .345-.28.625-.624.625h-.626a.625.625 0 0 1-.624-.625v-.693a2.853 2.853 0 0 1-1.242-.447.468.468 0 0 1-.06-.718l.684-.685a.482.482 0 0 1 .551-.079c.124.057.26.087.4.087h1.281a.33.33 0 0 0 .091-.646l-1.956-.558c-.869-.248-1.563-.966-1.676-1.863a2.198 2.198 0 0 1 1.926-2.462v-.686c0-.345.28-.625.626-.625h.624c.346 0 .626.28.626.625v.693c.446.052.87.202 1.24.447.244.16.267.512.061.718l-.684.685a.482.482 0 0 1-.551.079.958.958 0 0 0-.4-.087H9.322a.33.33 0 0 0-.091.646l1.956.558c.869.249 1.563.966 1.676 1.863a2.198 2.198 0 0 1-1.927 2.462z"
          fill={color}
          fillRule="nonzero"
        />
      </g>
    </g>
  </svg>
);

PreviewOnlyIcon.propTypes = propTypes;

export default PreviewOnlyIcon;
